import { StyledMissionNotification } from './notifications.styles';
interface MissionProgressNotificationProps {
  taskName: string;
  progressText: string;
  isTaskCompleted: boolean;
  isMissionCompleted?: boolean;
}
export const MissionProgressNotification = ({
  taskName,
  progressText,
  isTaskCompleted
}: MissionProgressNotificationProps) => {
  return <StyledMissionNotification data-sentry-element="StyledMissionNotification" data-sentry-component="MissionProgressNotification" data-sentry-source-file="mission-progress-notification.tsx">
      <h3>
        {progressText} {taskName}!
      </h3>
      <p>{isTaskCompleted ? 'Task complete!' : 'Levelling up in progress…'}</p>
    </StyledMissionNotification>;
};